import { render, staticRenderFns } from "./PopperColor.vue?vue&type=template&id=25a9c607"
import script from "./PopperColor.vue?vue&type=script&lang=js"
export * from "./PopperColor.vue?vue&type=script&lang=js"
import style0 from "./PopperColor.vue?vue&type=style&index=0&id=25a9c607&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports